import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import type { AiFeature, AiUsageResponse } from './ai-usage.model';

@Injectable({ providedIn: 'root' })
export class AiUsageService {
  private readonly http = inject(HttpClient);
  private readonly _usage = signal<AiUsageResponse | null>(null);

  readonly usage = this._usage.asReadonly();

  remainingFor(feature: AiFeature): number | null {
    return this._usage()?.features[feature]?.remainingToday ?? null;
  }

  load(): Observable<AiUsageResponse> {
    return this.http.get<AiUsageResponse>(`${environment.apiBaseUrl}/ai/usage`).pipe(
      tap((usage) => this._usage.set(usage)),
    );
  }

  refresh(): void {
    this.load().pipe(catchError(() => EMPTY)).subscribe();
  }
}
